var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamante(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 193.293,
    height: 187.132,
    viewBox: "0 0 51.142 49.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 313.514,
    cy: 62.321,
    r: 130.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#edcc30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    style: {
      stopColor: "#ecc62f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#e7b32b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    style: {
      stopColor: "#e19624"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#dc8120"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    style: {
      stopColor: "#d46f1b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    style: {
      stopColor: "#c24911"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 280.445,
    cy: 52.523,
    r: 114.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#edcc30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    style: {
      stopColor: "#ecc62f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#e7b32b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    style: {
      stopColor: "#e19624"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#dc8120"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    style: {
      stopColor: "#d46f1b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    style: {
      stopColor: "#c24911"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 362.843,
    cy: 65.461,
    r: 106.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#edcc30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    style: {
      stopColor: "#ecc62f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#e7b32b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    style: {
      stopColor: "#e19624"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#dc8120"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    style: {
      stopColor: "#d46f1b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    style: {
      stopColor: "#c24911"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 255.337,
    cy: 113.762,
    r: 103.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#edcc30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    style: {
      stopColor: "#ecc62f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#e7b32b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    style: {
      stopColor: "#e19624"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#dc8120"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    style: {
      stopColor: "#d46f1b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    style: {
      stopColor: "#c24911"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 362.839,
    cy: 36.502,
    r: 196.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#edcc30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    style: {
      stopColor: "#ecc62f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#e7b32b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    style: {
      stopColor: "#e19624"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#dc8120"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    style: {
      stopColor: "#d46f1b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    style: {
      stopColor: "#c24911"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 338.573,
    cy: 61.133,
    r: 196.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#edcc30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    style: {
      stopColor: "#ecc62f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#e7b32b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    style: {
      stopColor: "#e19624"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#dc8120"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    style: {
      stopColor: "#d46f1b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    style: {
      stopColor: "#c24911"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 214.625,
    cy: 188.214,
    r: 264.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#edcc30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    style: {
      stopColor: "#ecc62f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#e7b32b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    style: {
      stopColor: "#e19624"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#dc8120"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    style: {
      stopColor: "#d46f1b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    style: {
      stopColor: "#c24911"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 1407.759,
    cy: -28.332,
    r: 299.058,
    gradientTransform: "matrix(-1 0 0 1 1795.235 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#edcc30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    style: {
      stopColor: "#ecc62f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#e7b32b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    style: {
      stopColor: "#e19624"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#dc8120"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    style: {
      stopColor: "#d46f1b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    style: {
      stopColor: "#c24911"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 281.918,
    cy: 279.22,
    r: 206.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#edcc30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    style: {
      stopColor: "#ecc62f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#e7b32b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    style: {
      stopColor: "#e19624"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#dc8120"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    style: {
      stopColor: "#d46f1b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    style: {
      stopColor: "#c24911"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: 1059.085,
    cy: 1173.685,
    r: 196.617,
    gradientTransform: "rotate(134.243 871.668 563.572)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#edcc30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    style: {
      stopColor: "#ecc62f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#e7b32b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    style: {
      stopColor: "#e19624"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#dc8120"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    style: {
      stopColor: "#d46f1b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    style: {
      stopColor: "#c24911"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 291.229,
    cy: 676.278,
    r: 196.621,
    gradientTransform: "rotate(51.097 826.666 545.513)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#edcc30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    style: {
      stopColor: "#ecc62f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#e7b32b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    style: {
      stopColor: "#e19624"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#dc8120"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    style: {
      stopColor: "#d46f1b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    style: {
      stopColor: "#c24911"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "y",
    cx: 245.227,
    cy: 115.086,
    r: 20.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#dcd3ea"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#dad0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    style: {
      stopColor: "#d2c8e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    style: {
      stopColor: "#c5bad8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831,
    style: {
      stopColor: "#b3a6ca"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    style: {
      stopColor: "#9c8cb7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9382b0"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "z",
    cx: 318.492,
    cy: 168.397,
    r: 26.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#edcc30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    style: {
      stopColor: "#ecc62f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#e7b32b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    style: {
      stopColor: "#e19624"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#dc8120"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    style: {
      stopColor: "#d46f1b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    style: {
      stopColor: "#c24911"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M317.977 129.509h34.767l-20.105-29.486h-27.224z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M268.408 100.023h37.007l12.562 29.486h-62.131z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m317.977 129.509-31.066 97.981-31.065-97.981z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m221.079 129.509 20.104-29.486h27.225l-12.562 29.486z",
    style: {
      fill: "url(#d)"
    },
    transform: "translate(-50.886 -18.563)scale(.26458)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50.886 -18.563)scale(.26458)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    style: {
      overflow: "visible",
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.779 79.515 8.59 55.49 23.856-2.049z",
    clipPath: "url(#f)",
    style: {
      opacity: 0.11,
      fill: "url(#g)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50.886 -18.563)scale(.26458)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    style: {
      overflow: "visible",
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.472 62.547 15.921 102.835 44.209-3.797z",
    clipPath: "url(#i)",
    style: {
      opacity: 0.25,
      fill: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.207 87.178 15.92 102.835 44.21-3.797z",
    clipPath: "url(#i)",
    style: {
      opacity: 0.25,
      fill: "url(#k)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m221.079 129.509 65.832 97.981-31.065-97.981z",
    style: {
      fill: "url(#m)"
    },
    transform: "translate(-50.886 -18.563)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.744 129.509-65.833 97.981 31.066-97.981z",
    style: {
      fill: "url(#p)"
    },
    transform: "translate(-50.886 -18.563)scale(.26458)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50.886 -18.563)scale(.26458)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    style: {
      overflow: "visible",
      fill: "url(#u)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.723 192.836-84.778-60.344-28.124 34.321z",
    clipPath: "url(#v)",
    style: {
      opacity: 0.25,
      fill: "url(#w)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.776 160.884-70.033 76.968 30.718 32.02z",
    clipPath: "url(#v)",
    style: {
      opacity: 0.25,
      fill: "url(#x)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M221.079 129.509c2.897-.243 5.794-.382 8.692-.531a476 476 0 0 1 8.692-.308 607 607 0 0 1 17.383-.207l-.961.635c1.069-2.448 2.105-4.91 3.202-7.345 1.091-2.438 2.172-4.881 3.303-7.302 2.239-4.853 4.537-9.68 7.018-14.429-1.706 5.079-3.596 10.081-5.544 15.057-.962 2.493-1.975 4.965-2.977 7.441-.997 2.478-2.055 4.931-3.079 7.398l-.264.635-.698.001a607 607 0 0 1-17.383-.207 476 476 0 0 1-8.692-.308c-2.898-.148-5.795-.287-8.692-.53",
    style: {
      fill: "url(#y)"
    },
    transform: "translate(-50.886 -18.563)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.911 227.49a1218 1218 0 0 1-31.066-97.982 1218 1218 0 0 1 31.066 97.982m45.728-127.467c4.968 7.264 14.941 21.852 19.868 29.138l.203.299-.209.32c-5.1 7.81-10.271 15.573-15.486 23.304-15.677 23.178-31.604 46.187-48.282 68.661 14.965-23.649 30.701-46.79 46.684-69.758a1871 1871 0 0 1 16.169-22.835l-.006.619c-4.746-7.385-14.239-22.333-18.941-29.748m-16.846 24.359a159 159 0 0 1 2.494 5.104l-.032.112c-2.057 7.398-4.335 14.733-6.895 21.973-.84 2.418-1.72 4.823-2.664 7.209.603-2.493 1.27-4.966 1.977-7.426 2.079-7.393 4.443-14.7 7.025-21.932l.01.202a165 165 0 0 1-1.915-5.242m-9.273 41.262c-1.073 4.192-2.433 8.808-3.65 12.985l-1.323 4.295-.13.421-.438-.097-5.162-1.146.512-.858 4.029 4.652.178.205-.081.254a378 378 0 0 1-5.689 16.365 377 377 0 0 1 4.779-16.654l.096.459-4.1-4.589-1.114-1.247 1.626.389 5.143 1.23-.567.324c1.792-5.544 3.847-11.55 5.891-16.988",
    style: {
      fill: "#9382b0"
    },
    transform: "translate(-50.886 -18.563)scale(.26458)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50.886 -18.563)scale(.26458)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 268.305,
    cy: 120.044,
    r: 2.402,
    style: {
      opacity: 0.25,
      fill: "#dc8120"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.905 143.66a2.402 2.402 0 1 0-.623-4.763 2.402 2.402 0 0 0 .623 4.763m61.744 31.01a2.402 2.402 0 1 0-.623-4.763 2.402 2.402 0 0 0 .623 4.763m15.32-50.945a2.403 2.403 0 1 0-.624-4.764 2.403 2.403 0 0 0 .624 4.764m-82.066 0a2.4 2.4 0 0 0 2.07-2.694 2.401 2.401 0 1 0-4.764.624 2.403 2.403 0 0 0 2.694 2.07m29.768-11.639a.89.89 0 1 0 1.78 0 .89.89 0 0 0-1.78 0m2.159 8.366a.89.89 0 1 0 1.78 0 .89.89 0 0 0-1.78 0m-3.049 19.046a.89.89 0 1 0 1.78 0 .89.89 0 0 0-1.78 0m43.717 11.464a.89.89 0 1 0 1.78 0 .89.89 0 0 0-1.78 0m-28.242-10.574a.89.89 0 1 0 1.78 0 .89.89 0 0 0-1.78 0m28.242 20.496a.89.89 0 1 0 1.78 0 .89.89 0 0 0-1.78 0m-37.841 8.111a.89.89 0 1 0 1.78 0 .89.89 0 0 0-1.78 0",
    style: {
      opacity: 0.25,
      fill: "#dc8120"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m295.935 181.591 10.979 2.591-6.272 1.898z",
    style: {
      fill: "url(#z)"
    },
    transform: "translate(-50.886 -18.563)scale(.26458)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamante);
export default __webpack_public_path__ + "static/media/diamante.3acc08236064cb4418500dd053863ed1.svg";
export { ForwardRef as ReactComponent };